import { Sentry } from '@shared/lib/sentry'
import { Button } from '@shared/ui/button'
import type { ErrorComponentProps } from '@tanstack/react-router'
import { Link, useRouter } from '@tanstack/react-router'
import { useEffect } from 'react'
import { HiMiniArrowPath } from 'react-icons/hi2'

export function DefaultCatchBoundary({ error }: ErrorComponentProps) {
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])
  const router = useRouter()

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-5 bg-bg-base px-6">
      <div className="text-center">
        <p className="typo-heading font-bold text-foreground">문제가 발생했어요</p>
        <p className="mt-2 typo-label text-muted-foreground">
          일시적인 오류에요. 잠시 후 다시 시도해 주세요
        </p>
      </div>

      <div className="flex gap-2">
        <Button
          variant="outline"
          size="lg"
          onClick={() => {
            router.invalidate()
          }}
        >
          다시 시도
          <HiMiniArrowPath className="size-4" />
        </Button>
        <Link to="/">
          <Button variant="primary" size="lg">
            홈으로 돌아가기
          </Button>
        </Link>
      </div>
    </div>
  )
}
